// src/components/StickyCall.js
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaPhone, FaTimes } from "react-icons/fa";
import theme from "../styles/theme";

const StickyContainer = styled.div`
  position: fixed;
  bottom: ${theme.spacing[6]};
  right: ${theme.spacing[6]};
  z-index: ${theme.zIndex.toast};
  display: none;
  
  @media (max-width: ${theme.breakpoints.lg}) {
    display: ${props => props.show ? 'block' : 'none'};
  }
`;

const StickyButton = styled.button`
  background: ${theme.gradients.accent};
  color: white;
  border: none;
  border-radius: ${theme.borderRadius.full};
  padding: ${theme.spacing[4]} ${theme.spacing[6]};
  font-size: ${theme.typography.fontSize.base};
  font-weight: ${theme.typography.fontWeight.semibold};
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
  transition: all ${theme.animation.normal} ease;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  min-width: 200px;
  justify-content: center;
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    min-width: 180px;
    padding: ${theme.spacing[3]} ${theme.spacing[5]};
    font-size: ${theme.typography.fontSize.sm};
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -${theme.spacing[2]};
  right: -${theme.spacing[2]};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${theme.secondary[600]};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.fontSize.xs};
  cursor: pointer;
  transition: all ${theme.animation.fast} ease;

  &:hover {
    background: ${theme.secondary[700]};
  }
`;

const StickyCall = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show the sticky CTA after scrolling 500px down
      const scrolled = window.scrollY > 500;
      setShow(scrolled && !dismissed);
    };

    // Check if user has dismissed it before
    const isDismissed = localStorage.getItem('stickyCtaDismissed') === 'true';
    setDismissed(isDismissed);

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial scroll position

    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed]);

  const handleClick = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setDismissed(true);
    localStorage.setItem('stickyCtaDismissed', 'true');
  };

  return (
    <StickyContainer show={show}>
      <StickyButton onClick={handleClick}>
        <FaPhone />
        Book Free Consultation
        <CloseButton onClick={handleDismiss}>
          <FaTimes />
        </CloseButton>
      </StickyButton>
    </StickyContainer>
  );
};

export default StickyCall;
